
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/hub/subcomponents/stream/templates/new_content_marker"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='streamComponent-activityHeader streamComponent-activityHeader--newMessages'>\n  <div class='streamComponent-activityHeaderText'>New</div>\n  <hr class='hr--medium'>\n</div>\n";
},"useData":true});
    }).call(this);
  